__turbopack_context__.v({
  "container": "HeycarImage-module__Z4QT3a__container",
  "image": "HeycarImage-module__Z4QT3a__image",
  "isStandAlone": "HeycarImage-module__Z4QT3a__isStandAlone",
  "shimmer": "HeycarImage-module__Z4QT3a__shimmer",
});
